/**
 * ─── ADMIN PANEL FUNKSIYA BAYROQLARI (feature flags) ────────────────────────
 *
 * Bu yerda UI darajasidagi "yoq/o'chir" bayroqlari turadi. Bayroq bilan
 * o'chirilgan funksiyaning KODI HECH QACHON O'CHIRILMAYDI — u shartli
 * ko'rsatiladi, shuning uchun qaytarish bitta qatorni almashtirish bilan bo'ladi.
 */

/**
 * ─── PREMIUM MUZLATISH BAYROG'I (2026-08-15 qarori) ─────────────────────────
 *
 * NIMA UCHUN: Premium (ota-onalar uchun pullik obuna) mantiqi VAQTINCHA
 * muzlatildi. Bazadagi barcha PARENT akkauntlariga 2027-12-31 gacha premium
 * berib qo'yilgan, backend'da `src/lib/premium.ts` → `PREMIUM_ENABLED = false`:
 *   • `isPremium()` hammaga `true` qaytaradi (hech kim cheklanmaydi),
 *   • premium SOTIB OLISH / SOVG'A / berish-bekor qilish endpointlari 403 beradi
 *     (`PATCH /superadmin/parents/:id` butunlay, `/premium/*` esa tanasida
 *     premium maydoni bo'lsa),
 *   • o'qish endpointlari (ota-onalar ro'yxati, sovg'alar tarixi) ishlayveradi.
 * Mobil ilovada ham xuddi shu bayroq bor: `app/src/config.ts` →
 * `PREMIUM_UI_ENABLED = false`.
 *
 * Ya'ni: admin panelda premiumga tegishli har qanday tugma AMALDA ISHLAMAYDI
 * (403), premium ustunlari esa hammaga bir xil "2027-yilgacha" ko'rsatib,
 * chalg'ituvchi ma'lumot berardi. Shu sababli UI to'liq YASHIRILADI.
 *
 * NIMA QILADI: `false` bo'lganda:
 *   • yon menyu va Spotlight'dan `/premium`, `/saas-premium`, `/saas-gifts`
 *     bandlari olib tashlanadi (`lib/nav.ts` + `lib/permissions.ts`
 *     → `PREMIUM_SECTIONS`);
 *   • bu marshrutlar OCHIQ qoladi, lekin sahifa o'rniga "vaqtincha o'chirilgan"
 *     holati chiziladi (`components/FeatureFrozen.tsx`) — oq ekran yoki
 *     chalg'ituvchi "Ruxsat yo'q" xabari EMAS;
 *   • Ota-onalar / Ota-ona kartochkasi / Support ekranlaridagi premium ustuni,
 *     filtri, tojli (crown) nishoni va sovg'a hisoblagichlari ko'rinmaydi;
 *   • banner uchun ilovaning "Premium" ekraniga havola taklif qilinmaydi
 *     (ilova bunday bannerni baribir chizmaydi — `HomeBanners.tsx`);
 *   • bildirishnomalar filtridan `PREMIUM` turi olib tashlanadi (eski
 *     bildirishnomalar o'zi ro'yxatda ko'rinaveradi, ikonkasi ham saqlanadi).
 *
 * QANDAY QAYTARILADI: shu qatorda `false` → `true`. Boshqa hech narsa
 * o'zgartirilmaydi. Backend'da ham (`lib/premium.ts`) va ilovada ham
 * (`app/src/config.ts`) mos bayroqni yoqish kerak — aks holda UI ko'rinadi-yu,
 * tugmalar 403 qaytaradi.
 *
 * MUHIM: i18n kalitlari (`premiumPage.*`, `saasPremiumPage.*`, `saasGiftsPage.*`,
 * `parentsPage.sortPremium`, `parentDetail.giftsSent/giftsReceived` va h.k.)
 * ATAYLAB SAQLANGAN — hozir ishlatilmasa ham, bayroq qaytarilganda darhol kerak.
 *
 * Tur ATAYLAB `boolean` (literal `false` emas): aks holda TypeScript
 * `PREMIUM_UI_ENABLED && ...` shoxlarini `never` deb toraytirib, bayroqni
 * qaytarish paytida yolg'on xatolar chiqaradi.
 */
export const PREMIUM_UI_ENABLED: boolean = false;
